export default __webpack_public_path__ + "static/media/Group 6514@3x.c897b94e.png";